import React from 'react';
import { useTranslation } from 'react-i18next';
import useConfig from 'app/hooks/useConfig';
import { Svg } from 'app/components';
import { useFontSize } from 'app/context/FontSizeRoute';
import { generateUniqueId } from 'utils';
import { SignInLink } from './styles';
import { linkTo } from 'utils';

export default function LoginButton() {
  const [t] = useTranslation();
  const { routes } = useConfig();
  const { fontSize } = useFontSize();

  return (
    <SignInLink fontSize={fontSize} to={linkTo(routes.login.pattern)} activeClassName="_active" id={`logIn-link-${generateUniqueId()}`}>
      <Svg id="user" />
      <span className='login-name'>{t('common.login')}</span>
    </SignInLink>
  );
}
